/**
 * ITFlowValidationModalBody.js
 * Created by calhosh on 2/10/2022.
 */

import React from 'react';
import styled from 'styled-components';
import Utility from '../../../../util/utilityfunctions';
import {labels} from '../../../../util/utils';
import ResourceWithLink from '../../ResourceWithLink/ResourceWithLink';

const ITFlowValidationModalBody = ({engagement, displayLanguage}) => {
	const openItSummary = () => {
		window
			.open(Utility.getCanvasBaseUrl(engagement, displayLanguage) + '&hashRoute=itsummary#itsummary', '_blank')
			.focus();
	};

	const onPlaceholderClickConfig = {
		itSummaryLink: openItSummary
	};

	return (
		<StyledModalBody>
			<ResourceWithLink
				placeholder={labels.itFlowModalDescription}
				onPlaceholderClickConfig={onPlaceholderClickConfig ? onPlaceholderClickConfig : () => {}}
			/>
		</StyledModalBody>
	);
};

export default React.memo(ITFlowValidationModalBody);

const StyledModalBody = styled.section`
	display: flex;
	font-size: var(--px-16);
	margin: var(--px-20);
`;
